import { ensureActive17z6c489wymmv as ensureActive } from './Emitters.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NopCollector_instancer81kq14zk5tc as NopCollector_instance } from './internal/NopCollector.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_emitAll__ugcct6(_this__u8e3s4, flow, $completion) {
  ensureActive(_this__u8e3s4);
  var tmp = flow.b1d(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function emitAll(_this__u8e3s4, flow, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_emitAll__ugcct6.bind(VOID, _this__u8e3s4, flow), $completion);
}
function collect(_this__u8e3s4, $completion) {
  return _this__u8e3s4.b1d(NopCollector_instance, $completion);
}
//region block: exports
export {
  collect as collect17bovwmirntks,
  emitAll as emitAll2ll41gkd5meqr,
};
//endregion

//# sourceMappingURL=Collect.mjs.map
